import { Channel } from 'app/constants/channel';
import { RestfulModel, StoreAttributes } from 'app/model';
import { ModelWithoutId } from 'app/type/model-with-id';

import { Brand } from './brand';
import { SpendInfo } from './spend-info';

export interface Store extends RestfulModel<number> {
    name: string;
    storeNum?: string;
    isDefault: boolean;
    locationId?: number;
    phone?: string;
    brand?: Brand;
    timeCreated?: string;
    type?: string;
    domain?: string;
    storeownerId?: number;
    midGiven?: string;
    dateOpened?: string;
    dateClosed?: string;

    source?: string;

    tagSource?: string;

    defaultChannel?: Channel;
    inProd: boolean;

    oldStores?: number[];
    /**
     * Computed value at time of request
     */
    spendInfo?: SpendInfo;

    attributes?: StoreAttributes[];
}

export const makeBlankStore = <T extends Partial<Store>>(props?: T): ModelWithoutId<Store> & T => {
    const defaults: ModelWithoutId<Store> = {
        name: '',
        isDefault: false,
        inProd: false,
        attributes: [],
        source: '',
        tagSource: '',
    };

    return {
        ...defaults,
        ...props,
    } as ModelWithoutId<Store> & T;
};
